/**
 * @file
 * Accordion script.
 */

(function accordionScript($, Drupal, _) {
  'use strict';

  Drupal.behaviors.accordion = {
    attach: function accordionAttach(context) {
      var hash = window.location.hash;
      if (hash) {
        var entity_id = hash.substr(9);
        var element = document.querySelectorAll("[data-entity-id='" + entity_id + "']");
        if (element) {
          $(element).parents('.accordion-tab').addClass('is-open');
        }
      }

      var openAccordion = $('.accordion.accordion--open');
      openAccordion.children().first('.accordion-tab').addClass('is-open');
      openAccordion.find('.accordion-tab__title').first().attr('aria-expanded', 'true');
      openAccordion.find('.accordion-tab__content').first().attr('aria-hidden', 'false');


      $('.accordion-tab > .accordion-tab__title ').click(function () {
        var $this = $(this);
        $('.is-open > .accordion-tab__title').attr('aria-expanded', 'false');
        $('.is-open > .accordion-tab__content').attr('aria-hidden', 'true');
        $this.parent().siblings().removeClass('is-open');
        if ($this.parent().hasClass('is-open')) {
          $this.parent().removeClass('is-open');
          $this.attr('aria-expanded', 'false');
          $this.siblings('.accordion-tab__content').attr('aria-hidden', 'true');
        }
        else {
          $this.parent().addClass('is-open');
          $this.attr('aria-expanded', 'true');
          $this.siblings('.accordion-tab__content').attr('aria-hidden', 'false');
        }
        return false;
      });
    }
  };
}(jQuery, Drupal, _));
